import { ComponentPropsWithoutRef, FC } from 'react';

export const ProfileHeightLgIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="256" height="400" viewBox="0 0 256 400" fill="none" {...props}>
    <g clipPath="url(#clip0_3109_67917)">
      <path
        d="M115.433 326.559V374.713H115.447L126.252 386.103H126.295L139.478 400H101.825L92.5196 390.646V400H81.8882V381.661V351.223V326.559H115.433Z"
        fill="black"
      />
      <path
        d="M164.655 326.559V374.713H164.67L175.474 386.103H175.517L188.7 400H151.047L141.742 390.646V400H131.11V381.661V351.223V326.559H164.655Z"
        fill="black"
      />
      <path
        d="M127.333 325.987C166.177 325.987 197.667 294.332 197.667 255.285C197.667 216.237 166.177 184.583 127.333 184.583C88.4893 184.583 57 216.237 57 255.285C57 294.332 88.4893 325.987 127.333 325.987Z"
        fill="#1B1F2C"
      />
      <path d="M175.878 205.732H77.4341L66.2837 334.138H187.035L175.878 205.732Z" fill="#1B1F2C" />
      <path
        d="M126.656 179.438C119.779 179.438 113.17 180.597 107.007 182.727V339.108H146.297V182.727C140.134 180.597 133.532 179.438 126.648 179.438H126.656Z"
        fill="black"
      />
      <path
        d="M77.4341 205.732C77.4341 178.402 99.4682 156.252 126.656 156.252C153.844 156.252 175.878 178.402 175.878 205.732"
        fill="black"
      />
      <path d="M175.881 217.145L126.657 167.664L77.4337 217.145L126.657 266.627L175.881 217.145Z" fill="black" />
      <path
        d="M144.905 191.031C154.976 201.155 154.971 217.585 144.905 227.704L126.665 246.041L108.424 227.704C98.3526 217.58 98.3577 201.15 108.424 191.031C118.495 180.907 134.84 180.912 144.905 191.031Z"
        fill="#0477BD"
      />
      <path d="M187.042 329.167H66.2837V341.985H187.042V329.167Z" fill="black" />
      <path
        d="M110.964 169.244H144.934V204.529C144.934 213.956 137.323 221.607 127.946 221.607C118.568 221.607 110.957 213.956 110.957 204.529V169.244H110.964Z"
        fill="#039BE5"
      />
      <path d="M144.935 172.867H110.964V191.575H144.935V172.867Z" fill="#0477BD" />
      <path
        d="M157.765 82V136.458C157.765 157.781 140.545 175.091 119.333 175.091H114.706V120.633C114.706 99.3096 131.925 82 153.137 82H157.765Z"
        fill="#0477BD"
      />
      <path d="M74.248 136.878H117.495V180.351C93.6297 180.351 74.248 160.868 74.248 136.878Z" fill="#039BE5" />
      <path
        d="M131.816 120.633V175.091H127.189C105.977 175.091 88.7573 157.781 88.7573 136.458V82H93.3846C114.597 82 131.816 99.3096 131.816 120.633Z"
        fill="#039BE5"
      />
      <path d="M124.609 120.981V120.633C124.609 104.2 111.981 90.6727 95.9653 89.354V120.981H124.609Z" fill="#0477BD" />
      <path
        d="M146.621 177.395H119.368C98.2065 177.395 82.1044 158.288 85.5857 137.305L88.3968 120.343C91.2582 103.092 106.106 90.4482 123.499 90.4482H142.484C159.883 90.4482 174.731 103.092 177.586 120.343L180.397 137.305C183.878 158.288 167.776 177.395 146.614 177.395H146.621Z"
        fill="#039BE5"
      />
      <path
        d="M134.13 145.312H199C199 169.302 179.618 188.785 155.753 188.785H134.13C122.194 188.785 112.507 179.047 112.507 167.048C112.507 155.05 122.194 145.312 134.13 145.312Z"
        fill="#E7F2F1"
      />
      <path
        d="M197.018 158.354C198.301 154.238 199 149.862 199 145.319H184.167C184.167 152.477 189.911 158.288 197.018 158.354Z"
        fill="#1B1F2C"
      />
      <path
        d="M189.5 126.401C189.5 136.255 181.55 144.247 171.747 144.247C161.945 144.247 153.995 136.255 153.995 126.401"
        fill="black"
      />
      <path
        d="M148.762 133.516C148.762 139.442 143.983 144.246 138.087 144.246C132.191 144.246 127.413 139.442 127.413 133.516"
        fill="black"
      />
      <path d="M86.2061 133.516H179.777L178.573 126.271H87.4097L86.2061 133.516Z" fill="black" />
      <path
        d="M119.931 126.271H141.554C145.533 126.271 148.762 129.517 148.762 133.516H127.139C123.16 133.516 119.931 130.27 119.931 126.271Z"
        fill="#0477BD"
      />
    </g>
    <defs>
      <clipPath id="clip0_3109_67917">
        <rect width="142" height="318" fill="white" transform="translate(57 82)" />
      </clipPath>
    </defs>
  </svg>
);
